import React from 'react';

/**
 * React.lazy route with one transient-network retry and an explicit preloader.
 * A rejected promise is cleared so a later navigation can try the chunk again.
 */
export function createLazyRoute(loader, { retryDelayMs = 250 } = {}) {
  let modulePromise;
  let RouteComponent;
  let failed = false;
  const preload = () => {
    modulePromise ||= loader()
      .catch(() => new Promise((resolve) => {
        setTimeout(resolve, retryDelayMs);
      }).then(loader))
      .catch((error) => {
        modulePromise = null;
        failed = true;
        throw error;
      });
    return modulePromise;
  };
  preload.reset = () => {
    if (!failed) return false;
    failed = false;
    RouteComponent = React.lazy(preload);
    return true;
  };

  /*
   * React.lazy는 한 번 거부된 타입의 오류를 기억한다. 라우터가 새 화면
   * 진입 전에 preload.reset()을 호출하면 실패한 타입만 깨끗하게 교체한다.
   */
  function LazyRoute(props) {
    return React.createElement(RouteComponent, props);
  }

  RouteComponent = React.lazy(preload);
  LazyRoute.displayName = 'LazyRoute';
  return [LazyRoute, preload];
}
